import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import BaseIsCustomBadge, {
  IsCustomBadgeProps,
} from "components/Shared/IsCustomBadge";

const fragment = gql(/* GraphQL */ `
  fragment RetailerIsCustomBadge on Retailer {
    id
    forBrandId
  }
`);

type Fragment = FragmentType<typeof fragment>;

export function getIsRetailerCustom(retailer: Fragment) {
  const { forBrandId } = getFragmentData(fragment, retailer);

  if (forBrandId === undefined) return undefined;

  return forBrandId !== null;
}

type Props = Omit<IsCustomBadgeProps, "isCustom"> & {
  retailer: Fragment;
};

export default function IsCustomBadge({ retailer, ...rest }: Props) {
  return (
    <BaseIsCustomBadge isCustom={getIsRetailerCustom(retailer)} {...rest} />
  );
}
